import { Space, Tabs } from "antd";
import styles from "./teacher-view-tabs.module.css";
import CustomButton from "../../../../common/custom-button/custom-button";
import SVGIcon from "../../../../constants/SVGIcon";
import AcademicView from "../academic-view/academic-view";
import { useState } from "react";
import BulkUpload from "../../../../components/bulk-upload/bulk-upload";
import { bulkUploadTeacher } from "../../../../services/teachers";
import { toast } from "react-toastify";
import RoutesConstant from "../../../../constants/routes";
import { useNavigate } from "react-router-dom";
import AllTeachersList from "../all-teachers-tab/all-teachers-tab";

export function TeacherViewTabs() {
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const [error, setError] = useState([]);
  const navigate = useNavigate();
  const [triggerRefetch, setTriggerRefetch] = useState(0);

  const handleAddTeacher = () => {
    navigate(RoutesConstant.TEACHER_FORM);
  };

  const items = [
    {
      key: "1",
      label: "All",
      children: <AllTeachersList triggerRefetch={triggerRefetch} />,
    },
    {
      key: "2",
      label: "Academic View",
      children: <AcademicView triggerRefetch={triggerRefetch} />,
    },
  ];

  const operations = (
    <div className={styles.tab_actions}>
      <Space
        direction="horizontal"
        wrap
        style={{ justifyContent: "center", display: "flex", width: "100%" }}
      >
        <CustomButton
          title="Add Teacher"
          size="large"
          icon={
            <SVGIcon
              name="add-icon"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={handleAddTeacher}
        />
        <CustomButton
          title="Bulk Upload"
          size="large"
          icon={
            <SVGIcon
              name="upload"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={() => setShowBulkUpload(!showBulkUpload)}
        />
      </Space>
    </div>
  );

  const handleBulkUpload = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const resp = await bulkUploadTeacher(formData);
      if (resp?.data?.data?.errors?.length) {
        setError(resp?.data?.data?.errors);
      } else {
        setShowBulkUpload(false);
        setTriggerRefetch((prev) => prev + 1);
        toast.success("Teachers Creations is Successful");
      }
    } catch (err) {
      setError(err?.data?.data?.errors);
      toast.error(err?.data?.message || "Something error occurred");
    }
  };

  return (
    <div className={styles.teacher_view_tabs}>
      <>
        <div className={styles.tab_actions_mobile}>{operations}</div>

        <Tabs
          defaultActiveKey="1"
          items={items}
          tabBarStyle={{ borderBottom: "none" }}
          tabBarExtraContent={
            <div className={styles.tab_actions_desktop}>{operations}</div>
          }
        />
      </>
      <BulkUpload
        open={showBulkUpload}
        errors={error}
        accepts=".xlsx"
        onClose={() => setShowBulkUpload(!showBulkUpload)}
        handleClickUpload={handleBulkUpload}
        isStudentPage={false}
      />
    </div>
  );
}

export default TeacherViewTabs;
